import { useEffect, useState, type ReactNode } from "react";
import { useDispatch, useSelector } from "react-redux";
import { type Dispatch, type UnknownAction } from "redux";

import { userDetail } from "../../actions";
import { WfpManagerMainNavigation } from "../../components/WfpManagerMainNavigation";
import type { Country } from "../../components/WfpManagerMainNavigation/types";
import type { NavigationUser } from "../../components/NavigationUserMenu/types";
import { getCountryObjectFromCache, redirect } from "../../utils";
import { setupCountry } from "../../utils/authentication";
import { ensureSelectedCountry, storeCountryCode } from "../../utils/countryStorage";

type RootState = {
  userDetail?: { data?: NavigationUser };
};

type WfpManagerHeaderProps = {
  children: ReactNode;
};

const handleCountryChange = (countryCode: string) => {
  storeCountryCode(countryCode);
  redirect("/wfpManager");
};

export const WfpManagerHeader = ({ children }: WfpManagerHeaderProps) => {
  const dispatch = useDispatch<Dispatch<UnknownAction>>();
  const currentUser = useSelector((state: RootState) => state.userDetail?.data);
  const [country] = useState<Country>(getCountryObjectFromCache);

  useEffect(() => {
    dispatch(userDetail() as unknown as UnknownAction);
    const countryCode = ensureSelectedCountry();

    if (countryCode) {
      setupCountry(countryCode);
    }
  }, [dispatch]);

  return (
    <WfpManagerMainNavigation
      country={country}
      onCountryChange={handleCountryChange}
      user={currentUser}
    >
      {children}
    </WfpManagerMainNavigation>
  );
};
